import { makeStyles, tokens, makeResetStyles } from "@fluentui/react-components";

export const useTabMenuStyles = makeStyles({
  root: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    "padding-left": "10px",
    "padding-right": "10px",
    rowGap: "10px",
  },
  panels: {
    width: "100%",
    "padding-right": "10px",
    "& th": {
      textAlign: "left",
      "padding-right": "30px",
    },
  },
  propsTable: {
    "& td:first-child": {
      fontWeight: tokens.fontWeightSemibold,
    },
    "& td": {
      "padding-right": "30px",
      "padding-top": "10px",
    },
  },
  listbox: {
    maxHeight: "160px",
  },
  input: {
    width: "100%",
  },
});
